import React, { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { 
  FaArrowLeft, 
  FaFlag, 
  FaIndustry 
} from 'react-icons/fa';
import { TbBrandCarbon } from 'react-icons/tb';
import { PiCigarette } from 'react-icons/pi';
import { IoIosMedical } from 'react-icons/io';
import { 
  MdOutlineHdrStrong, 
  MdRemove, 
  MdAdd 
} from 'react-icons/md';
import { WiDust } from 'react-icons/wi';
import { GiStoneBlock } from 'react-icons/gi';
import DialogBoxReview from '../components/dialogboxrewiew';
import { CartContext } from '../contexts/CartContext';
import toast from 'react-hot-toast';
import Photo from '../components/Photo';
import { Helmet } from 'react-helmet'; 

import './details.css';

const Details = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  
  const [apiUrl, setApiUrl] = useState('');

  useEffect(() => {
    fetch('/templates/api.txt')
      .then((res) => res.text())
      .then((data) => {
        setApiUrl(data.trim());
      })
      .catch((err) => console.error('Ошибка при загрузке API URL:', err));
  }, []);

  useEffect(() => {
    if (!apiUrl) return;
    const fetchProduct = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${apiUrl}api/products/${slug}`);
        setProduct(response.data);
        console.log('Details Page: Товар загружен:', response.data);
      } catch (err) {
        setError('Не удалось загрузить информацию о продукте.');
        console.error('Details Page: Ошибка загрузки товара:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchProduct();
  }, [apiUrl, slug]);

  
  const [hoveredStar, setHoveredStar] = useState(0);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [quantity, setQuantity] = useState(1);

  const filterOptions = [
    { name: 'Топ 25', color: '#32CD32' },
    { name: 'Подарочные', color: '#FF5733' },
    { name: 'Бестселлер', color: '#FFD700' },
    { name: 'Новинки', color: '#33C1FF' },
    { name: 'Лимитированная серия', color: '#8A2BE2' },
    { name: 'Свежее поступление', color: '#FF1493' },
  ];

  const { addToCart } = useContext(CartContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleMouseEnter = (index) => setHoveredStar(index);
  const handleMouseLeave = () => setHoveredStar(0);
  const handleStarClick = (index) => {
    setHoveredStar(index);
    setIsDialogOpen(true);
  };

  const renderStars = () => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <span
          key={i}
          className={`star ${i <= hoveredStar ? 'hovered' : ''}`}
          onMouseEnter={() => handleMouseEnter(i)}
          onMouseLeave={handleMouseLeave}
          onClick={() => handleStarClick(i)}
        >
          ★
        </span>
      );
    }
    return stars;
  };

  const handleDecrease = () => setQuantity((prev) => (prev > 1 ? prev - 1 : 1));
  const handleIncrease = () => setQuantity((prev) => (prev < 99 ? prev + 1 : 99));

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      const num = parseInt(value, 10);
      if (isNaN(num) || num < 1) {
        setQuantity(1);
      } else if (num > 99) {
        setQuantity(99);
      } else {
        setQuantity(num);
      }
    }
  };

  const handleAddToCart = () => {
    if (product) {
      addToCart(product, quantity);
      toast.success('Товар добавлен в корзину!');
      console.log(
        `Details Page: Товар добавлен в корзину: ${product.title}, количество: ${quantity}`
      );
    }
  };

  if (loading) {
    return (
      <div className="details-spinner-container">
        <div className="details-spinner"></div>
      </div>
    );
  }

  if (error) {
    return <p className="details-error-message">{error}</p>;
  }

  if (!product) {
    return <p className="details-error-message">Продукт не найден.</p>;
  }

  
  const metaDescriptionParts = [];
  if (product.attributes['Бренд']) {
    metaDescriptionParts.push(`Бренд: ${product.attributes['Бренд']}`);
  }
  if (product.attributes['Вкус/Аромат']) {
    metaDescriptionParts.push(`Вкус: ${product.attributes['Вкус/Аромат']}`);
  }
  if (product.attributes['Крепость']) {
    metaDescriptionParts.push(`Крепость: ${product.attributes['Крепость']}`);
  }
  const metaDescription = metaDescriptionParts.join('. ');

  return (
    <div className="details-product-detail-wrapper">
      {/* МЕТАТЕГИ для карточки товара */}
      <Helmet>
        <title>{`${product.title} | Nicotine Club`}</title>
        <meta
          name="description"
          content={
            metaDescription.length > 0
              ? metaDescription
              : `Информация о товаре ${product.title}`
          }
        />
        <meta
          name="keywords"
          content="каталог сигарет, купить сигареты оптом, табак для кальяна, сигареты Marlboro, сигареты Winston, табак для самокруток, сигареты Parliament, табак Dark Side, купить табак для кальяна"
        />
      </Helmet>

      {/* Кнопка назад */}
      <button
        className="details-back-arrow-button"
        onClick={() => navigate('/catalog')}
      >
        <FaArrowLeft />
      </button>

      <div className="details-flex-container">
        <div className="details-image-container">
          <div className={product.inStock ? '' : 'details-out-of-stock-blur'}>
            <Photo
              src={product.image_base64 || product.image}
              alt={product.title}
              apiUrl={apiUrl}
              className="details-centered-image"
            />
            {product.inStock && product.filters && (
              <div className="details-filters-container">
                {filterOptions
                  .filter((option) => product.filters.includes(option.name))
                  .map((option) => (
                    <div key={option.name} className="details-filter-item">
                      <div
                        className="details-filter-circle"
                        style={{ backgroundColor: option.color }}
                      ></div>
                      <span>{option.name}</span>
                    </div>
                  ))}
              </div>
            )}
          </div>
          {!product.inStock && (
            <div className="details-out-of-stock-text">Нет в наличии</div>
          )}
        </div>

        <div className="details-new-container">
          <div className="details-stock-status">
            {product.inStock ? 'В наличии' : 'Нет в наличии'}
          </div>
          <h1 className="details-title">{product.title}</h1>
          <p className="details-price">
            {product.price.toLocaleString()} ₽
          </p>

          <div className="details-rating">{renderStars()}</div>

          {/* Характеристики */}
          <div className="details-additional-info">
            <div className="details-info-item">
              <span className="details-info-label">Бренд:</span>
              <span className="details-info-value">
                <TbBrandCarbon className="brand-icon" />
                {product.attributes['Бренд'] || '—'}
              </span>
            </div>
            <div className="details-info-item">
              <span className="details-info-label">Тип табака:</span>
              <span className="details-info-value">
                <PiCigarette className="type-icon" />
                {product.attributes['Тип табака'] || '—'}
              </span>
            </div>
            <div className="details-info-item">
              <span className="details-info-label">Вкус/Аромат:</span>
              <span className="details-info-value">
                <IoIosMedical className="taste-icon" />
                {product.attributes['Вкус/Аромат'] || '—'}
              </span>
            </div>
            <div className="details-info-item">
              <span className="details-info-label">Крепость:</span>
              <span className="details-info-value">
                <MdOutlineHdrStrong className="strength-icon" />
                {product.attributes['Крепость'] || '—'}
              </span>
            </div>
          </div>

          <div className="details-additional-info" style={{ marginTop: '20px' }}>
            <div className="details-info-item">
              <span className="details-info-label">Никотин, мг:</span>
              <span className="details-info-value">
                <WiDust style={{ width: 16, height: 16, marginRight: 5 }} />
                {product.attributes['Никотин, мг'] || '—'}
              </span>
            </div>
            <div className="details-info-item">
              <span className="details-info-label">Страна:</span>
              <span className="details-info-value">
                <FaFlag style={{ width: 16, height: 16, marginRight: 5 }} />
                {product.attributes['Страна производства'] || '—'}
              </span>
            </div>
            <div className="details-info-item">
              <span className="details-info-label">Пачек в блоке:</span>
              <span className="details-info-value">
                <GiStoneBlock style={{ width: 16, height: 16, marginRight: 5 }} />
                {product.attributes['Сигарет в пачке'] || '—'}
              </span>
            </div>
            <div className="details-info-item">
              <span className="details-info-label">Производитель:</span>
              <span className="details-info-value">
                <FaIndustry style={{ width: 16, height: 16, marginRight: 5 }} />
                {product.attributes['Производитель'] || '—'}
              </span>
            </div>
          </div>

          <div className="details-button-and-quantity">
            <button
              className="details-add-to-cart-button-custom"
              onClick={handleAddToCart}
            >
              В корзину
            </button>
            <div className="details-quantity-selector">
              <MdRemove className="quantity-icon" onClick={handleDecrease} />
              <input
                type="text"
                className="details-quantity-input"
                value={quantity}
                onChange={handleInputChange}
              />
              <MdAdd className="quantity-icon" onClick={handleIncrease} />
            </div>
          </div>
        </div>
      </div>

      <DialogBoxReview
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
      />
    </div>
  );
};

export default Details;
